<template>
  <div>
    <div class="flex flex-row justify-around mt-5">
      <gauge-chart v-for="(item, index) in data.datasets"
                   :key="index"
                   :label="item.label"
                   :data="item.data"
                   :chartLabels="data.labels"
                   :colorPalette="colorPalette"
                   :compareColor="colorPalette.lineChartCompare"
                   :percentage="item.percentage.toString()"
                   :update="update">
      </gauge-chart>
    </div>
  </div>
</template>

<script setup>
import {defineEmits, defineProps, onMounted, ref, watch} from "vue";
import GaugeChart from "@/widgetContent/charts/GaugeChart";
import ApiService from "@/services/ApiService";
let apiService = new ApiService;
const emit = defineEmits(["dataLoaded"])

let props = defineProps({
  update: Number,
  source: String,
  style: Object,
  colorPalette: Object,
  pills: Array,
  type: String,
  hasLongTitle: Boolean
})

let data = ref(Object);
let quantityLabels = ref(Array);
let loaded = ref(false);

onMounted ( async () => {
  await getData()
})

async function getData(){
  data.value = await apiService.get(props.source);
  emit("dataLoaded")
  quantityLabels.value = data.value.labels
  loaded.value = true;
}

watch( () => props.update, async () => {
  await getData();
})
</script>
